// extracted by mini-css-extract-plugin
export default {"tarjetaContacto":"DatosGeneralesComponent_tarjetaContacto__URxnz","circuloContacto":"DatosGeneralesComponent_circuloContacto__YVxut"};